import { styled, CSSObject } from '../theming';
import { fontFamily } from '../utils/BabbelFonts';
import { focusStyles } from '../utils/focusStyles';

// https://alxgbsn.co.uk/2011/10/17/enable-css-active-pseudo-styles-in-mobile-safari/
if (typeof document !== 'undefined') {
  document.addEventListener('touchstart', function () {}, false);
}

export const baseButtonStyles: CSSObject = {
  display: 'inline-block',
  border: 'none',
  margin: 0,
  padding: 0,
  width: 'auto',
  overflow: 'visible',
  background: 'transparent',
  /* inherit font & color from ancestor */
  color: 'inherit',
  font: 'inherit',
  textAlign: 'inherit',
  textTransform: 'inherit',
  boxSizing: 'border-box',
  /* Corrects font smoothing for webkit */
  '-webkit-font-smoothing': 'inherit',
  '-moz-osx-font-smoothing': 'inherit',
  /* Corrects inability to style clickable input types in iOS */
  '-webkit-appearance': 'none',
  cursor: 'pointer',
  ':disabled': {
    cursor: 'default',
  },
  userSelect: 'none',
  touchAction: 'manipulation',
  '-webkit-tap-highlight-color': 'transparent',

  /* some default styles */
  ...fontFamily(),
  whiteSpace: 'nowrap',
};

export const BaseButtonWithoutFocus = styled.button(baseButtonStyles);

// :active https://bugzilla.mozilla.org/show_bug.cgi?id=68851

BaseButtonWithoutFocus.defaultProps = {
  type: 'button',
  // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#attr-autocomplete
  ['autocomplete' as string]: 'off',
};

/**
 * Utility component to reset built-in styles of a button while preserving accessibility affordances such as focus styling.
 *
 * [online documentation](https://doc.babbel.com/lessonnine/design-system.lib/index.html?path=/docs/components-utils-basebutton--default-story)
 */
export const BaseButton = styled(BaseButtonWithoutFocus)`
  ${({ theme }) => focusStyles({ theme })}
`;
